
export const EarlyAccessBenefits = () => {
  return (
    <div className="rounded-lg bg-blue-900/20 border border-blue-700/50 p-4 mt-6">
      <h3 className="text-blue-400 font-medium mb-2">Early Access Benefits</h3>
      <p className="text-sm text-gray-300">
        Early access members receive exclusive preferential pricing, with complete access to our powerful AI trading technology, priority introduction to new features, and dedicated one-on-one support. Upon submission, our team will personally contact you to discuss membership details and customized options tailored to your specific needs.
      </p>
    </div>
  );
};
